<form #prodForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/category']">Product Category</a> > {{ category.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(prodForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="category.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Name Required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <mat-tab-group animationDuration="0ms" class="mt-4">
        <mat-tab id="digital_processes" label="Digital Processes">
          <div class="row mt-3">
            <div class="example-container col-sm-6">
              <h4>Digital Processes</h4>
              <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #todoList="cdkDropList" [cdkDropListData]="unmappedDigitalProcess" [cdkDropListConnectedTo]="[doneList]" class="example-list" (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of unmappedDigitalProcess" cdkDrag>{{ item['name'] }}</div>
              </div>
            </div>
            <div class="example-container col-sm-6">
              <h4>Mapped Digital Processes</h4>
              <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #doneList="cdkDropList" [cdkDropListData]="mappedDigitalProcess" [cdkDropListConnectedTo]="[todoList]" class="example-list" (cdkDropListDropped)="drop($event)" required>
                <div class="example-box" *ngFor="let item of mappedDigitalProcess" cdkDrag>{{ item['name'] }}</div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab id="physical_processes" label="Physical Processes">
          <div class="row mt-3">
            <div class="example-container col-sm-6">
              <h4>Physical Processes</h4>
              <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #todoList1="cdkDropList" [cdkDropListData]="unmappedPhysicalProcess" [cdkDropListConnectedTo]="[doneList1]" class="example-list" (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of unmappedPhysicalProcess" cdkDrag>{{ item['name'] }}</div>
              </div>
            </div>
            <div class="example-container col-sm-6">
              <h4>Mapped Physical Processes</h4>
              <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #doneList1="cdkDropList" [cdkDropListData]="mappedPhysicalProcess" [cdkDropListConnectedTo]="[todoList1]" class="example-list" (cdkDropListDropped)="drop($event)" required>
                <div class="example-box" *ngFor="let item of mappedPhysicalProcess" cdkDrag>{{ item['name'] }}</div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

      <div cdkDropList #listOne="cdkDropList" [cdkDropListConnectedTo]="[listTwo]"></div>
      <div cdkDropList #listTwo="cdkDropList" [cdkDropListConnectedTo]="[listOne]"></div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="product_category" [recordId]="category.id"></app-audit-log-viewer>
</form>
